import { useState } from "react";
import { ToastProvider } from "@/components/base/Toast";
import type { SchoolPlan } from "@/types";
import LandingHeader from "./components/LandingHeader";
import HeroSection from "./components/HeroSection";
import PlatformSection from "./components/PlatformSection";
import FeaturesSection from "./components/FeaturesSection";
import OfflineSection from "./components/OfflineSection";
import HowItWorksSection from "./components/HowItWorksSection";
import PricingSection from "./components/PricingSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import LandingFooter from "./components/LandingFooter";
import RequestAccountModal from "./components/RequestAccountModal";

function LandingContent() {
  const [requestOpen, setRequestOpen] = useState(false);
  const [requestPlan, setRequestPlan] = useState<SchoolPlan>("ETABLISSEMENT");
  const openRequest = (plan: SchoolPlan = "ETABLISSEMENT") => {
    setRequestPlan(plan);
    setRequestOpen(true);
  };

  return (
    <div className="min-h-screen bg-background-100">
      <LandingHeader onRequest={() => openRequest()} />
      <main>
        <HeroSection onRequest={() => openRequest()} />
        <PlatformSection />
        <FeaturesSection />
        <OfflineSection />
        <HowItWorksSection onRequest={() => openRequest()} />
        <PricingSection onRequest={openRequest} />
        <FaqSection />
        <CtaSection onRequest={() => openRequest()} />
      </main>
      <LandingFooter onRequest={() => openRequest()} />
      <RequestAccountModal open={requestOpen} initialPlan={requestPlan} onClose={() => setRequestOpen(false)} />
    </div>
  );
}

export default function Landing() {
  return (
    <ToastProvider>
      <LandingContent />
    </ToastProvider>
  );
}